import { QueryClient } from '@tanstack/react-query';
import { callQueryClientPaginatedRedVelvetQuery } from '../hooks/paginatedRedVelvetQuery';

export const PAPI_MAX_CHARACTER_INPUT = 100;

/**
 * Search for Amazon employees via PAPI. Returns null if the input is empty or
 * exceeds the character limit, otherwise returns the raw people array.
 */
export async function searchPeople(
  filteringText: string,
  queryClient: QueryClient,
  featureFlags: string[]
) {
  if (!filteringText || filteringText.length >= PAPI_MAX_CHARACTER_INPUT) {
    return null;
  }
  const data = await callQueryClientPaginatedRedVelvetQuery(
    queryClient,
    { redVelvetQueryKey: ['getPeople', { people: filteringText, pageSize: 10 }] },
    featureFlags
  );
  return data?.people ?? [];
}
